// extracted by mini-css-extract-plugin
export default {"rating":"dJ-z","numberOfStars":"eJ-z","count":"fJ-z","barGraphSpacing":"gJ-z","barGraph":"hJ-z"};